<template>
  <el-dialog :close-on-click-modal="false" class="add-course-package" :visible.sync="dialogVisible">
    <div class="title">平台证书课程包</div>
    <div class="close-icon" @click="dialogVisible = false">
      <i class="el-icon-close"></i>
    </div>
    <div class="content">
      <table-list
        ref="coursePackageTable"
        :loading="loading"
        :data="coursePackageList"
        :search-form="searchForm(this)"
        :columns="columns(this)"
        :options="{ selection: true, height: 400 }"
        @search="onSearch"
        @selectionChange="handleSelectionChange"
      ></table-list>
      <div class="btns">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submit">确定</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
const searchForm = _this => [
  {
    label: '证书',
    prop: 'certId',
    type: 'select',
    children: _this.certList.map(item => ({
      value: item.certId,
      label: item.certName,
    })),
  },
]
// 表格列配置
const columns = () => [
  {
    prop: 'certName',
    label: '适用证书',
  },
  {
    prop: 'courseDetail',
    label: '课程清单',
  },
  {
    prop: 'courseType',
    label: '课程类型',
    formatter: row => ['录播', '直播'][row.courseType],
  },
  {
    prop: 'teacherName',
    label: '任课老师',
  },
  {
    prop: 'durationTotal',
    label: '课程时长(分)',
  },
]
import TableList from '@/components/TableList'
import { classCertCoursePacket, classCertCoursePacketAdd, certOrgQuery } from '@/api/certificate'
import to from 'await-to'
export default {
  name: 'AddCoursePackage',
  components: { TableList },
  props: {
    classCertId: {
      type: [Number, String],
      default: '',
    },
  },
  data() {
    return {
      searchForm,
      columns,
      dialogVisible: false,
      loading: false,
      certList: [],
      coursePackageList: [],
      select: [],
      queryParams: {},
    }
  },
  methods: {
    show(select = []) {
      this.dialogVisible = true
      this.getCertList()
      this.getList()
      this.$nextTick(() => {
        this.$refs.coursePackageTable.$refs.tableList.clearSelection()
        if (select.length) {
          select.forEach(row => {
            this.$refs.coursePackageTable.$refs.tableList.toggleRowSelection(row)
          })
        }
      })
    },
    async getCertList() {
      const [res, err] = await to(certOrgQuery({}))
      if (err) return this.$message.warning(err.msg)
      this.certList = res.data
    },
    async getList() {
      if (this.loading) return
      this.loading = true
      const [res, err] = await to(
        classCertCoursePacket({ ...this.queryParams, classCertId: this.classCertId }),
      )
      this.loading = false
      if (err) return this.$message.warning(err.msg)
      this.coursePackageList = res.data
    },
    async submit() {
      const [, err] = await to(
        classCertCoursePacketAdd({
          packetId: this.select.map(item => item.id),
          classCertId: this.classCertId,
        }),
      )
      if (err) return this.$message.warning(err.msg)
      this.$message.success('添加成功')
      this.$emit('success')
      this.dialogVisible = false
    },
    // 查询按钮
    onSearch(queryParams) {
      this.queryParams = queryParams
      this.getList()
    },
    // 多选
    handleSelectionChange(val) {
      this.select = val
    },
  },
}
</script>
<style lang="scss" scoped>
.add-course-package {
  ::v-deep .el-dialog {
    position: relative;
    width: 1000px;
    background: #ffffff;
    border-radius: 0;
    color: #4d4e5d;
    .close-icon {
      z-index: 99;
      cursor: pointer;
      position: absolute;
      right: 24px;
      top: 14px;
      font-size: 25px;
      font-weight: bold;
      color: #8c8c8c;
    }
    .el-dialog__header {
      display: none;
    }
    .el-tabs__header {
      margin-bottom: 26px;
      padding-top: 23px;
    }
    .el-dialog__body {
      padding: 0;
    }
    .title {
      height: 62px;
      line-height: 62px;
      border-bottom: 1px solid #c9c9c9;
      padding-left: 30px;
      font-size: 18px;
    }
    .content {
      padding: 30px 10px;
      > .btns {
        text-align: right;
        padding-top: 30px;
      }
    }
    .el-form-item {
      .el-input,
      .el-select,
      .el-date,
      .el-date-editor {
        width: 200px !important;
      }
    }
  }
}
</style>
